import generateSettings from '../helpers/Settings';
import styles from './styles';
import content from './content';

export default (container = document) => {
  const modules = container.querySelectorAll('[data-cms-module-hero-banner]');
  modules.forEach((module, i) => {
    const module_name = 'HeroBanner';
    const settingsElement = module.querySelector('[data-settings]');
    const settings = generateSettings(settingsElement ? settingsElement.innerHTML : '');

    if (!settings) {
      return;
    }

    settings.blog_name = module.getAttribute('data-blog-name');
    settings.publish_date = module.getAttribute('data-article-publish-date');
    settings.author_name = module.getAttribute('data-article-author');

    const styles_html = styles(settings, module_name, i);
    const content_html = content(settings, module_name, i);
    const module_width = `Section--${settings.module_width} Section--mobile-${settings['module_width--mobile']}`;

    const new_html = `
    <section
      id="Module-${module_name}--${i}"
      data-section-id="${module_name}--${i}"
      data-section-type=""
      class="CMS-Module Module-${module_name} Section ${module_width}"
    >
      <div class="Section__bg" style="background-image:url('${settings.background_texture}');">
        <img class="Module-${module_name}__Bg Section__bg--image" src="${settings.background_image}" alt="${module_name}" width="2340" height="1075" style="aspect-ratio: auto 2340/1075" />
        <div class="Section__container">
        ${content_html}
        </div>
      </div>
    </section>
    ${styles_html}
    `;

    module.innerHTML = new_html;
  });
};
